// extracted by mini-css-extract-plugin
module.exports = {"version":"styles_version__whOKe"};